import { useState, useCallback } from "react"
import { SlideJsonResponsive } from "types"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore, { Autoplay, Pagination } from "swiper"
import { SliderConstant } from "src/config/sliderConstant"
import { useMount } from "react-use"
import { useViewerResize } from "src/components/viewer/hooks/useViewerResize"

// クリエイタートップの見出しのスライダー

type Props = {
  slides: SlideJsonResponsive[]
}

SwiperCore.use([Autoplay, Pagination])

const HeroSlideShow: React.FC<Props> = ({ slides }) => {
  const [isPc, setIsPc] = useState<boolean>(false)

  const handleResize = useCallback(() => {
    window.matchMedia(`(max-width: ${SliderConstant.SpMaxWidth})`).matches
      ? setIsPc(false)
      : setIsPc(true)
  }, [])

  useViewerResize(handleResize)

  useMount(() => {
    if (
      window.matchMedia(`(max-width: ${SliderConstant.SpMaxWidth})`).matches
    ) {
      setIsPc(false)
    }
  })

  const createSlideContent = (slide: SlideJsonResponsive) => {
    if (!slide.link_url) {
      return (
        <picture>
          <source
            srcSet={slide.image_url_sp}
            media={`(max-width: ${SliderConstant.SpMaxWidth})`}
          />
          <img src={slide.image_url_pc} alt={slide.title} />
        </picture>
      )
    }

    return (
      <a
        href={slide.link_url}
        target={slide.is_blank ? "_blank" : "_self"}
        rel="noreferrer"
        style={{ display: "block" }}
      >
        <picture>
          <source
            srcSet={slide.image_url_sp}
            media={`(max-width: ${SliderConstant.SpMaxWidth})`}
          />
          <img src={slide.image_url_pc} alt={slide.title} />
        </picture>
      </a>
    )
  }

  return (
    <div className="creator-heroSlider">
      <Swiper
        spaceBetween={22}
        slidesPerView={isPc ? 1.37 : 1}
        centeredSlides
        loop
        autoplay
        pagination={{ clickable: true }}
      >
        {slides.map((slide, idx) => (
          <SwiperSlide key={idx}>{createSlideContent(slide)}</SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default HeroSlideShow
